import React from "react";
import Radium, { StyleRoot } from "radium";
import styles from "../styles/testimonialContent";

function TestimonalContent({ brand, person, company, description }) {
  return (
    <StyleRoot>
      <div style={styles.wrapper}>
        <div style={styles.topSection}>
          <img
            src={`https://cdn-s3.touchofmodern.com/partners/assets/vendor-${brand}.png`}
            style={styles.imageIcon}
            width="90"
            alt={person}
          />
          <div style={styles.topText}>
            <div style={styles.person}>{person}</div>
            <div style={styles.company}>{company}</div>
          </div>
        </div>
        <div style={styles.description}>{description}</div>
      </div>
    </StyleRoot>
  );
}

export default TestimonalContent;
